export default class PdfProofRequest {
	prepressInstructionsUrl: string
	ParametersUrl: string
	constructor() {
		this.prepressInstructionsUrl = ""
		this.ParametersUrl = ""
	}
}
